import { action } from 'satcheljs/lib/legacy';
import { trace } from 'owa-trace';
import { hasQueryStringParameter } from 'owa-querystring';
import { updateItemOnServer } from '../services/updateItemOnServer';
import { getStore } from '../store/store';
import ActionType from '../store/schema/ActionType';
import { logUsage } from 'owa-analytics';
const lightningQueryParamName = 'lightning';

/**
 * Action to complete the lightning callout and make the callout unvisible
 */
export default action('endLightning')(async function endLightning(
    id: string,
    actionType?: ActionType
): Promise<void> {
    trace.info(`endLightning - id:${id}`);
    let unseen = getStore().unseenItems;

    // Skip the update because the id didn't lightup or it is already dismissed
    if (!(unseen.has(id) && unseen.get(id)!.visible)) {
        return;
    }

    // Remove the lightning from the store
    unseen.delete(id);

    // log datapoint
    logUsage('Lighted', [id]);

    if (hasQueryStringParameter(lightningQueryParamName)) {
        trace.info('skipping the update because override exists');
        return;
    } else {
        return updateItemOnServer(id, actionType);
    }
});
